import React from 'react';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import If from '@components/If';

const StatisticsCell = ({ title, subtitle }: { title: string; subtitle?: string }) => {
  return (
    <TableCell>
      <Box width="100%" display="flex" flexDirection="column" alignItems="center" gap="5px">
        <Typography fontSize="0.8rem" flex="1">
          {title}
        </Typography>
        <If condition={!!subtitle}>
          <Typography fontSize="0.8rem" color="primary.main" flex="1">
            {subtitle}
          </Typography>
        </If>
      </Box>
    </TableCell>
  );
};
export default StatisticsCell;
